import BaseModel from '../base/BaseModel.model';
export default class Period extends BaseModel {

   public periodName: string = "";
   public code: string = "";
   public  periodId: number = 0;
    init(){
       this.periodName = "";
       this.code = "";
      this.periodId = 0;
    }
}